export type NewsStory = {
  slug: string;
  category: string;
  date: string;
  title: string;
  dek: string;
  byline: string;
  readTime: string;
  image: string;
  alt: string;
  caption: string;
  href: string;
  body: string[];
};

export const newsStories: NewsStory[] = [
  {
    slug: 'riviera-fleet-partnership',
    category: 'Partnership',
    date: 'October 2026',
    title: 'Superluxury partners with a private Riviera fleet of 47 superyachts',
    dek: 'None of the vessels are listed for charter. From this season, members may board them by introduction alone.',
    byline: 'By the Superluxury Desk',
    readTime: '6 min read',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/f7915f88-8f55-4e01-a2b6-cb01093d786c.jpg',
    alt: 'A dark-hulled superyacht anchored alone in a turquoise bay at golden hour',
    caption: 'One of the fleet’s vessels at anchor off the Riviera. Owners and crews are bound by the same confidentiality as the house.',
    href: '/news/riviera-fleet-partnership',
    body: [
      'There is a part of the Riviera that never appears on a charter list. Its yachts are moored where the public piers end, their owners known by first name to a handful of harbour masters, their crews recruited by word of mouth.',
      'From this season, forty-seven of those vessels — every one of them longer than fifty metres — will be available to Superluxury members by introduction. None will be advertised, and none will carry guests who have not been personally vouched for.',
      'The arrangement took two summers to agree. Owners asked for one assurance above all others: that their vessels would be treated as homes, not inventory. Each introduction is made in person, under NDA, and only after the owner has approved the guest.',
      'For members, the difference is felt before they ever step aboard. A berth in Villefranche held through the Grand Prix weekend. A captain who already knows the guests’ preferences. A tender waiting at a private jetty rather than a public quay.',
      'The fleet’s itineraries range from Saint-Tropez to the Aeolian Islands, with several vessels wintering in the Caribbean and the Gulf.',
    ],
  },
  {
    slug: 'monaco-hypercar-collection',
    category: 'Collaboration',
    date: 'September 2026',
    title: 'A private hypercar collection opens its doors in Monaco',
    dek: 'Twelve cars, one garage beneath the Principality, and a coast road reserved until dawn.',
    byline: 'By the Superluxury Desk',
    readTime: '5 min read',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/836b58fd-74a8-4dd1-b2a1-02a7aadba441.jpg',
    alt: 'A silver hypercar standing alone in a minimalist concrete gallery under a shaft of light',
    caption: 'A car from the collection in its gallery beneath Monaco. The owner has asked that the location remain unnamed.',
    href: '/news/monaco-hypercar-collection',
    body: [
      'The garage door lifts without a sound. Beneath one of Monaco’s quieter streets sits a collection that has rarely been seen — twelve hypercars, most of them built in numbers smaller than a dinner party.',
      'Its owner, a collector who has never given an interview, has agreed to open the collection to Superluxury members for private drives along the Grande Corniche, arranged at hours when the road belongs to almost no one.',
      'Each drive is accompanied by the collection’s own technician and begins with a private viewing of the gallery. Requests are considered individually, and the owner reserves the final word on every key handed over.',
      'For the collector, the motive is simple. Cars of this kind were built to be driven, not kept behind glass — but only by people who understand what they are holding.',
    ],
  },
  {
    slug: 'private-aviation-in-house',
    category: 'Aviation',
    date: 'August 2026',
    title: 'Long-range private aviation, now arranged entirely in-house',
    dek: 'A dedicated aviation team, aircraft on four-hour standby, and no third-party brokers between members and the runway.',
    byline: 'By the Superluxury Desk',
    readTime: '4 min read',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/43e7766a-3786-456f-a734-30bcebf94ab9.jpg',
    alt: 'A white private jet on an empty runway at blue hour with glowing cabin windows',
    caption: 'A long-range aircraft prepared for departure at dawn. Flight details are never shared beyond the crew.',
    href: '/news/private-aviation-in-house',
    body: [
      'Breakfast in Geneva, lunch on a terrace above the Aegean. For years, members asked for exactly that — and for years, the house relied on outside brokers to make it happen.',
      'That has now changed. Superluxury’s new aviation team arranges every flight directly, from aircraft selection and crew to catering and ground transfers, with long-range jets held on four-hour standby in Geneva, Dubai and Nice.',
      'Bringing aviation in-house also closes the last gap in discretion. Passenger manifests, routes and preferences no longer pass through a third party; they stay with the member’s own partner.',
      'Members can request a flight through their partner by phone, message or the request bar, and receive a confirmed aircraft within the hour.',
    ],
  },
  {
    slug: 'alpine-residences-winter',
    category: 'Residences',
    date: 'July 2026',
    title: 'Five alpine residences join the house for winter',
    dek: 'Chalets in Gstaad, Courchevel and St. Moritz — none of them listed, each held for a single member at a time.',
    byline: 'By the Superluxury Desk',
    readTime: '5 min read',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/91f834ab-30c3-4829-9c78-7691a701e1ff.jpg',
    alt: 'A contemporary stone villa on an alpine hillside at dusk with glowing windows and a reflecting pool',
    caption: 'One of the five residences at dusk. Addresses are shared only once a stay is confirmed.',
    href: '/news/alpine-residences-winter',
    body: [
      'The fire is lit before you arrive. In the valley below, no one knows whose chalet it is this week — and the owners prefer it that way.',
      'Five alpine residences in Gstaad, Courchevel and St. Moritz join the house this winter. None has ever been offered publicly, and each will be held for a single member at a time, with staff, a private chef and a driver arranged in advance.',
      'The owners chose Superluxury for the same reason members do: the assurance that their homes will be shared with very few people, and spoken of by even fewer.',
      'Stays are available from December to April, with the festive weeks already in high demand among existing members.',
    ],
  },
];
